<!-- static content data from lang: user_management -->
<template>
  <div>
    <div v-loading="loading">
      <base-header class="pb-6">
        <div class="row align-items-center pb-4">
          <div class="col-lg-12 col-12">
            <h6 class="h2 text-white d-inline-block mb-0">{{ lang.label.headerTitle }}</h6>
            <nav aria-label="breadcrumb" class="d-inline-block ml-4">
              <route-bread-crumb></route-bread-crumb>
            </nav>
          </div>
        </div>
      </base-header>
      <div class="container-fluid mt--6">
        <div>
          <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
            <div class="col-md-12">
              <template v-for="(message, i) in alertMessages">
                <Alert :type=alertType dismissible :key='i' v-if="message"> <span class="alert-inner--text">{{ message
                    }}
                  </span> <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span
                      aria-hidden="true">&times;</span> </button> </Alert>
              </template>
              <template v-for="(message, i) in successMessages">
                <Alert :type=successType dismissible :key='i' v-if="message"> <span class="alert-inner--text">{{ message
                    }} </span> <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span
                      aria-hidden="true">&times;</span> </button> </Alert>
              </template>
              <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <template>
                    <base-input alternative :label="lang.label.passport" labelClasses="form-control-label asterisk-mark"
                      class="mb-3" name="ID/passport" rules="required" prepend-icon="ni ni-single-02"
                      :placeholder="lang.label.passport + '*'" v-model="model.userName" autocomplete="off"
                      :disabled="true"></base-input>
                    <base-input alternative :label="lang.label.name" labelClasses="form-control-label asterisk-mark"
                      class="mb-3" name="name" rules="required" prepend-icon="fas fa-user-circle"
                      :placeholder="lang.label.name + '*'" v-model="model.name" autocomplete="off"></base-input>
                    <base-input alternative :label="lang.label.surname" labelClasses="form-control-label asterisk-mark"
                      class="mb-3" name="surname" rules="required" prepend-icon="far fa-user-circle"
                      :placeholder="lang.label.surname + '*'" v-model="model.surname" autocomplete="off"></base-input>
                    <base-input alternative :label="lang.label.emailAddress" class="mb-3" name="email address"
                      rules="email" prepend-icon="ni ni-email-83" :placeholder="lang.label.emailAddress"
                      v-model="model.emailAddress" autocomplete="off"></base-input>
                    <base-input alternative :label="lang.label.phoneNumber"
                      labelClasses="form-control-label asterisk-mark" class="mb-3" name="cell phone number"
                      :rules="{ required: true, numeric: true, digits: '10' }" prepend-icon="ni ni-mobile-button"
                      :placeholder="lang.label.phoneNumber + '*'" @input="copyToWhatsAppNumber"
                      @keypress="isNumber($event)" v-model="model.phoneNumber" autocomplete="off"></base-input>
                    <base-input alternative :label="lang.label.WhatsAppNumber"
                      labelClasses="form-control-label asterisk-mark" class="mb-3" name="whatsApp number"
                      :rules="{ required: true, numeric: true, digits: '10' }" prepend-icon="fab fa-whatsapp"
                      :placeholder="lang.label.WhatsAppNumber + '*'" @keypress="isNumber($event)"
                      v-model="model.WhatsAppNumber" autocomplete="off"></base-input>
                    <div class="form-group">
                      <base-input :label="lang.label.communicationType" labelClasses="form-control-label asterisk-mark"
                        name="communication type" :rules="{ required: true }">
                        <b-form-group class="mb-0">
                          <b-form-radio-group id="radio-group-co" v-model="model.communication" autocomplete="off"
                            :options="communicationType" name="radio-options-co"></b-form-radio-group>
                        </b-form-group>
                      </base-input>
                    </div>
                    <div class="form-group" v-if="imageUrl">
                      <base-input :label="lang.label.changeLogo" name="change photograph" :rules="{ required: true }">
                        <b-form-group class="mb-0">
                          <b-form-radio-group id="radio-group" v-model="change" autocomplete="off" :options="options"
                            name="radio-options"></b-form-radio-group>
                        </b-form-group>
                      </base-input>
                    </div>
                    <div class="form-group photo-upload">
                      <div class="row">
                        <div class="col-2" v-if="imageUrl ? change == 'Yes' : true">
                          <base-input :label="lang.label.uploadPhoto">
                            <vue-dropzone ref="myVueDropzone" id="myVueDropzone" :options="dropzoneOptions"
                              class="textFile" v-model="model.photo" autocomplete="off"
                              @vdropzone-file-added="filesAdded" @vdropzone-success="fileSuccess"
                              @vdropzone-removed-file="filesRemoved"></vue-dropzone>
                          </base-input>
                        </div>
                        <div class="col-4 pt-4 pl-3">
                          <img v-if="!fileAdded && imageUrl" height="150px" :src="imageUrl" alt="user photograph">
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <base-input :label="model.allowShareInformation == '1' ? lang.label.allowShareInformation : lang.label.notAllowedShareInformation" name="share information"
                        :rules="{ required: true }">
                        <b-form-group class="mb-0">
                          <b-form-radio-group id="radio-group1" v-model="model.allowShareInformation" autocomplete="off"
                            :options="allowShareInformation" name="radio-options1"></b-form-radio-group>
                        </b-form-group>
                      </base-input>
                    </div>
                    <div class="form-group">
                      <div v-for="(doc, index) in documentTypes" :key="doc.id" class="document-upload">
                        <div class="d-flex w-100 justify-content-between align-items-end">
                          <base-input :placeholder="doc.document_name" v-model="doc.name"
                            :label="'Upload ' + doc.typeName" :rules="{ required: true }" :name="'name' + index"
                            autocomplete="off" class="w-50 " labelClasses="form-control-label asterisk-mark">
                          </base-input>
                          <VueDropZone :multiple="false" :value="model.documentForms[index]" ref="testCompInstance"
                            @update:value="handleValueUpdate(index, $event)" @reload-files="handleReloadFiles"
                            :onFileUpload="(file, ref) => onFileAdded(index, file, ref)"
                            :document_type="doc.document_type" :dropzone-options="fileUploadOptions">
                          </VueDropZone>
                        </div>
                      </div>
                      <button class="btn btn-success" @click="addNewDocuments">Add more</button>
                    </div>
                    <div class="visited-sites">
                      <h2 class="section-title mb-4">
                        <i class="fas fa-building mr-2"></i>
                        Visited Sites
                      </h2>
                      <el-table
                        :data="siteDatas"
                        row-key="ID"
                        header-row-class-name="thead-light"
                        border
                        style="width: 100%"
                      >
                        <el-table-column type="expand">
                          <template slot-scope="props">
                            <div class="p-3">
                              <el-table
                                :data="getSiteDocuments(props.row)"
                                row-key="id"
                                header-row-class-name="thead-light"
                                border
                                style="width: 100%"
                              >
                                <el-table-column min-width="200px" label="Document Name" prop="document_name" sortable>
                                  <template slot-scope="scope">
                                    {{ scope.row.document_name || (scope.row.document_type && scope.row.document_type.name) || '' }}
                                  </template>
                                </el-table-column>
                                <el-table-column min-width="120px" label="ID" prop="id" sortable></el-table-column>
                                <el-table-column width="120px" align="right" label="Actions">
                                  <div class="d-flex" slot-scope="scope">
                                    <el-tooltip content="View" placement="bottom">
                                      <base-button class="btn-link" type="info" size="sm" icon @click="previewDocument(scope.row.document)">
                                        <i class="text-white fas fa-eye"></i>
                                      </base-button>
                                    </el-tooltip>
                                  </div>
                                </el-table-column>
                              </el-table>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column min-width="200px" label="Site Name" prop="SiteName" sortable>
                          <template slot-scope="scope">
                            {{ scope.row.SiteName || scope.row.name || '' }}
                          </template>
                        </el-table-column>
                        <el-table-column min-width="180px" label="Documents" sortable>
                          <template slot-scope="scope">
                            {{ getSiteDocuments(scope.row).length }} documents
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>

                    <div class="text-center">
                      <base-button type="primary" native-type="submit" class="mt-3" :disabled="uploading">{{
                        lang.label.buttons.submit }}</base-button>
                    </div>
                  </template>
                </form>
              </validation-observer>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Select, Option, Table, TableColumn, Tooltip } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import Alert from "@/components/BaseAlert.vue";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import state from "../../../store/state";
import { mapGetters } from "vuex";
import VueDropZone from "../../../components/VueDropZone.vue";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip,
    RouteBreadCrumb,
    Alert,
    vueDropzone: vue2Dropzone,
    VueDropZone
  },
  data() {
    return {
      alertType: 'danger',
      successType: 'success',
      alertMessages: [],
      successMessages: [],
      addedPersons: [],
      numberOfPersons: 1,
      change: 'No',
      changePhotos: [],
      options: [
        { text: "Yes", value: "Yes" },
        { text: "No", value: "No" }
      ],
      imageUrl: '',
      visitorId: null,
      fileAdded: false,
      photosAdded: [],
      lang: this.$lang.edit_visitor,
      notVerified: true,
      loading: false,
      uploading: false,
      model: {
        userName: "",
        name: "",
        emailAddress: "",
        phoneNumber: "",
        WhatsAppNumber: "",
        communication: [],
        allowShareInformation: "1",
        photo: "",
        uploadedFiles: [],
        documentForms: [],
      },
      fileUploadOptions: {
        url: "https://httpbin.org/post",
        maxFilesize: 5,
        acceptedFiles: ".pdf,.doc,.docx,.png,.jpg,.jpeg",
        dictDefaultMessage: "Drag files here or click to upload",
        dictFileTooBig: "File is too large ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
        dictInvalidFileType: "You can't upload files of this type.",
        autoProcessQueue: false,
        thumbnailWidth: 200,
        addRemoveLinks: false,
        uploadMultiple: false,
        capture: "image/*",
        previewTemplate: this.getTemplate()
      },
      otherInfo: {
        name: [],
        relation: [],
        photo: []
      },
      communicationType: [
        { text: "Email", value: "1" },
        { text: "SMS", value: "2" },
        // { text: "WhatsApp", value: "3" }
      ],
      allowShareInformation: [
        { text: "Yes", value: "1" },
        { text: "No", value: "0" },
      ],
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        addRemoveLinks: true,
        uploadMultiple: false,
        maxFilesize: 10,
        maxFiles: 1,
        acceptedFiles: ".jpg, .jpeg, .png",
        dictDefaultMessage:
          "<div class='upload-docs'><p>Drop file here <br/>or <br/>click to upload</p></div>"
      },
      companyName: [],
      siteName: [],
      selects: {
        simple: "Select"
      },
      roles: [
        { text: 'Administrator', value: 'Administrator', disabled: false },
        { text: 'Company Admin', value: 'Company Admin', disabled: false },
        { text: 'Site Admin', value: 'Site Admin', disabled: false },
        { text: 'Approve Access', value: 'Approve Access', disabled: true },
        { text: 'Visitor Questionnaires Access', value: 'Visitor Questionnaires Access', disabled: true },
        { text: 'Report Access', value: 'Report Access', disabled: true },
      ],
      selected: [],
      documentTypes: [],
      siteDatas: [],
    };
  },
  watch: {
    selected(val, oldVal) {
      if (val.includes("Site Admin") && !oldVal.includes("Company Admin")) {
        let temp = [0, 1];
        if (!val.includes("Approve Access")) {
          this.selected.push("Approve Access")
        }
        if (!val.includes("Visitor Questionnaires Access")) {
          this.selected.push("Visitor Questionnaires Access")
        }
        if (!val.includes("Report Access")) {
          this.selected.push("Report Access")
        }
        this.disableOthers(temp, true);
      } else {
        if (val.includes("Administrator")) {
          if (!val.includes("Report Access")) {
            this.selected.push("Report Access")
          }
          let temp = [1, 2];
          this.disableOthers(temp, true);
        } else if (!val.includes("Company Admin")) {
          if (val.includes("Report Access")) {
            this.selected.splice(this.selected.indexOf("Report Access"), 1)
          }
          let temp = [1, 2];
          this.disableOthers(temp, false);
        }
        if (val.includes("Company Admin")) {
          if (!val.includes("Site Admin")) {
            this.selected.push("Site Admin")
          }
          if (!val.includes("Approve Access")) {
            this.selected.push("Approve Access")
          }
          if (!val.includes("Visitor Questionnaires Access")) {
            this.selected.push("Visitor Questionnaires Access")
          }
          if (!val.includes("Report Access")) {
            this.selected.push("Report Access")
          }
          let temp = [0, 2];
          this.disableOthers(temp, true);
        } else if (!val.includes("Administrator")) {
          if (val.includes("Site Admin")) {
            this.selected.splice(this.selected.indexOf("Site Admin"), 1)
          }
          if (val.includes("Approve Access")) {
            this.selected.splice(this.selected.indexOf("Approve Access"), 1)
          }
          if (val.includes("Visitor Questionnaires Access")) {
            this.selected.splice(this.selected.indexOf("Visitor Questionnaires Access"), 1)
          }
          let temp = [0, 2];
          this.disableOthers(temp, false);
        }
      }

    },
    login(val) {
      if (val) {
        this.imageUrl = state.mediaURL + val.Photograph;
      }
    }
  },
  computed: {
    ...mapGetters({
      login: "login",
      disqualified: "disqualified",
    }),
    
  },
  mounted() {
    let self = this;
    this.fetchAllDocuments();
    self.visitSideList();
    if (this.disqualified) {
      if (this.disqualified && this.disqualified.includes('Based')) {
        self.alertMessages.push(this.disqualified);
      } else {
        self.successMessages.push(this.disqualified);
      }
      setTimeout(function () {
        self.alertMessages = [];
        self.successMessages = [];
        self.$store.commit('setDisqualified', '');
      }, 5000)
    }
    this.model.userName = this.login.Username;
    this.model.name = this.login.Name;
    this.model.surname = this.login.Surname;
    this.model.emailAddress = this.login.EmailAddress ? this.login.EmailAddress : '';
    this.model.phoneNumber = this.login.CellphoneNumber;
    this.model.WhatsAppNumber = this.login.WhatsAppNumber;
    this.model.communication = this.login.CommsPrefType;
    if (this.login.AllowShareInformation !== undefined && this.login.AllowShareInformation !== null) {
      this.model.allowShareInformation = this.login.AllowShareInformation ? 1 : 0;
    }
    if (this.login.Photograph) {
      this.imageUrl = state.mediaURL + this.login.Photograph;
    }
  },
  methods: {
    visitSideList() {
      this.$store.dispatch('visitorFormsList')
        .then(response => {
          this.siteDatas = response;
          this.loading = false;
        })
        .catch(error => {

        })
        .finally(() => this.loading = false);
    },
    getSiteDocuments(site) {
      if (!site) return [];
      const docs = Array.isArray(site.documents) ? site.documents : [];
      return docs;
    },
    fetchAllDocuments() {
      const self = this;
      return self.$store.dispatch('fetchDocuments')
        .then(response => {
          if (response.status == 200) {
            self.documentTypes = response.data.map(e => ({
              id: e.id,
              name: e.name || e.document_type.name,
              typeName: e.name || e.document_type.name,
              document_type: {
                id: e.id || e.document_type.id,
                name: e.name || e.document_type.name,
              }
            }));
            return self.uploadedDocuments();
          }
        })
        .catch(error => {
          console.error('Error fetching documents:', error);
        });
    },
    uploadedDocuments() {
      const self = this;
      return self.$store.dispatch('viewDocumnetsOfUser', self.login.ID)
        .then(response => {
          response.data.forEach(doc => {
            if (!doc.document_type) {
              self.documentTypes.push({
                id: null,
                name: doc.document_name || doc.document_type.name,
                typeName: "Other Document",
                documentRefId: doc.id
              });
            }
          });
          self.model.documentForms = self.documentTypes.map((e, i) => {
            let returnValue = [];
            if (response.data.some(doc => (doc.document_type && doc.document_type.id === e.id) || (!doc.document_type && doc.id === e.documentRefId))) {
              const responseDoc = response.data.filter(doc => ((doc.document_type && doc.document_type.id === e.id) || (!doc.document_type && doc.id === e.documentRefId)))[0];
              returnValue = [{
                ...responseDoc,
                name: responseDoc.document_name || responseDoc.document_type.name,
                document: state.mediaURL + responseDoc.document,
                isUploaded: true
              }];
            }
            return returnValue;
          });
        })
        .catch(error => {
          console.error('Error fetching documents:', error);
        });
    },
    addNewDocuments(e) {
      e.preventDefault();
      e.stopPropagation();

      this.documentTypes.push({
        id: null,
        name: "Other Document",
        typeName: "Other Document",
      });
      this.model.documentForms.push([{
        id: null,
        isNew: true,
        name: null,
        document: null,
        isUploaded: false
      }]);
    },
    handleFileUpload(file) {
      return true;
    },
    handleValueUpdate(index, value) {
      this.model.documentForms[index] = [value[0]];
    },
    getTemplate() {
      window.handleOpenFileInNewTab = this.handleViewURL

      return `
        <div class="upload-doc" data-file-url="" onclick="window.handleOpenFileInNewTab(this.dataset.fileUrl)">
          Click to preview
        </div>
      `;
    },
    handleViewURL(fileUrl) {
      fetch(fileUrl)
        .then(response => response.blob())
        .then(blob => {
          const objectURL = URL.createObjectURL(blob);
          window.open(objectURL, "_blank");
        })
        .catch(err => console.error('Error fetching the file:', err));
    },
    onFileAdded(index, file, ref) {
      return new Promise(async(resolve, reject) => {

        await this.$nextTick();
        let returnValue = true;
        const dropzone = ref;
        if (file.name.length > 100) {
          this.alertMessages.push(
            `File name is too long`
          );
          resolve(false);
          return;
        }
        this.model.documentForms[index] = this.model.documentForms[index] ? this.model.documentForms[index] : [];
        this.model.documentForms[index].file = file;
        let self = this;
        let formData = new FormData();
        formData.append('visitor', this.login.ID);
        formData.append('document_name', this.documentTypes[index].name);
        formData.append('document', file);
        if (this.documentTypes[index].id) {
          formData.append('document_type', this.documentTypes[index].id);
        }
        let method = "postDocumentForUser";
        let data = {
          data: formData
        }
        if (this.model.documentForms[index][0] && this.model.documentForms[index][0].id && !this.model.documentForms[index][0].isNew) {
          method = "updateDocumentForUser";
          data = {
            ...data,
            id: this.model.documentForms[index][0].id,
          };
        }
        this.$store.dispatch(method, data).then(response => {
          self.loading = false;
          if (response.status == 200) {
            console.log(response.data);
          }
        });
        if (dropzone.dropzone.files.length > 1) {
          dropzone.dropzone.removeFile(dropzone.dropzone.files[0]);
        }
        // this.fetchAllDocuments();

        resolve(returnValue);
      });
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    },
    onFileUploadSuccess(file, response) {
      console.log("File upload success:", file, response);
    },
    onFileRemoved(file) {
      console.log("File removed:", file);
    },
    isNumber: function (index, evt, flag = false) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      }
    },
    copyToWhatsAppNumber() {
      this.model.WhatsAppNumber = this.model.phoneNumber;
    },
    filesAdded(file) {
      this.observeFiles();
      this.fileAdded = true;
      this.uploading = true;
    },
    fileSuccess(file) {
      this.uploading = false;
    },
    observeFiles() {
      this.photosAdded = new Array(this.numberOfPersons);
      this.photosAdded[0] = this.$refs.myVueDropzone.dropzone.files.length ? true : false;
    },
    filesRemoved(file, error) {
      this.observeFiles();
      this.fileAdded = false;
      this.uploading = false;
    },
    disableOthers(data, flag) {
      let newRoles = this.roles;
      newRoles.forEach((object, index) => {
        if (flag) {
          if (this.selected.includes(object.value)) {
            this.roles[index].disabled = false;
          } else {
            this.roles[index].disabled = true;
          }
        } else {
          if (data.includes(index)) {
            this.roles[index].disabled = flag;
          }
          if (index > 2) {
            this.roles[index].disabled = true;
          }
        }
      });
    },
    onSubmit() {
      // Find documents that are missing or not uploaded
      const missingDocuments = this.documentTypes.filter((docType, index) => {
        return !this.model.documentForms[index] || !this.model.documentForms[index][0];
      });

      if (missingDocuments.length > 0) {
        const missingDocNames = missingDocuments
          .map(doc => doc.typeName || doc.name)
          .filter(name => name) // Remove any undefined/null values
          .join(', ');

        this.alertMessages.push(
          `Please upload the required documents: ${missingDocNames}`
        );
        this.loading = false;

        setTimeout(() => {
          this.alertMessages = [];
        }, 5000);
        return;
      }

      let self = this;
      this.loading = true;
      let formData = new FormData();
      formData.append('Username', this.model.userName);
      formData.append('Name', this.model.name);
      formData.append('Surname', this.model.surname);
      formData.append('EmailAddress', this.model.emailAddress);
      formData.append('CellphoneNumber', this.model.phoneNumber);
      formData.append('WhatsAppNumber', this.model.WhatsAppNumber);
      formData.append('CommsPrefType', this.model.communication);
      formData.append('AllowShareInformation', this.model.allowShareInformation);
      if (this.change == "Yes" || !this.imageUrl) {
        let imageFiles = this.$refs.myVueDropzone.dropzone.files;
        imageFiles.forEach((object) => {
          formData.append('Photograph', object);
        });
      }
      this.$store.dispatch('signUp', formData).then(response => {
        self.loading = false;
        if (response.status == 200) {
          let login = this.login;
          // self.$store.dispatch('getVisitor',this.model.userName).then(response =>{
          login.Username = response.data.Username;
          login.Name = response.data.Name;
          login.EmailAddress = response.data.EmailAddress;
          login.CellphoneNumber = response.data.CellphoneNumber;
          login.WhatsAppNumber = response.data.WhatsAppNumber;
          login.CommsPrefType = response.data.CommsPrefType;
          login.ID = response.data.ID;
          login.Photograph = response.data.Photograph;
          login.token = this.login.token;
          login.loginTime = this.login.loginTime;
          this.$store.commit('setLogin', null);
          this.$store.commit('setLogin', login);
          this.$store.commit('setPrevPage', true);
          self.successMessages.push('Information successfully updated');
          setTimeout(function () {
            self.successMessages = [];
          }, 3000);
          this.change = 'No';
          window.scrollTo(0, 0);
        } else {
          if (typeof response.data.message != 'object') {
            self.alertMessages.push(response.data.message);
            setTimeout(function () {
              self.alertMessages = [];
            }, 5000)
            window.scrollTo(0, 0);
          } else {
            var array = new Array();
            for (let key of Object.keys(response.data.message)) {
              let obj = response.data.message[key][0].includes('field') ? (key + "- " + response.data.message[key][0]) : response.data.message[key];
              array.push(obj)
            }
            self.alertMessages.push(array.join(', '));
            setTimeout(function () {
              self.alertMessages = [];
            }, 5000)
          }
        }
      });
    },
    handleReloadFiles() {
      this.loading = true;
      this.fetchAllDocuments()
        .finally(() => {
          this.loading = false;
        });
    },
    formatDate(date) {
      if (!date) return 'N/A';
      return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },
    previewDocument(document) {
      if (!document) {
        this.$notify({
          title: 'Warning',
          message: 'No document available for preview',
          type: 'warning'
        });
        return;
      }
      window.open(state.mediaURL + document, '_blank');
      // Your existing preview logic
    }
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}

.modal-header {
  padding-bottom: 0;
}

.vue-dropzone .dz-error-message {
  display: none;
  /* Temporarily hide error messages */
}

.dz-progress {
  display: none;
}

.section-title {
  color: #344767;
  font-weight: 600;
}

.site-card {
  transition: all 0.3s ease;
  border: none;
  overflow: hidden;
}

.site-card:hover {
  /* transform: translateY(-5px); */
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.bg-gradient-primary {
  background: linear-gradient(45deg, #5e72e4, #825ee4);
  border: none;
  padding: 1rem;
}

.document-item {
  transition: background-color 0.3s ease;
}

.document-item:hover {
  background-color: #f8f9fa;
}

.document-icon {
  font-size: 1.5rem;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: #f8f9fa;
}

.document-actions .btn {
  transition: all 0.3s ease;
}

.document-actions .btn:hover {
  transform: translateY(-2px);
}

.card-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  padding: 0.75rem 1rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .document-details h6 {
    font-size: 0.9rem;
  }

  .document-icon {
    font-size: 1.2rem;
    width: 32px;
    height: 32px;
  }
}

/* Animation for card loading */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.site-card {
  animation: fadeInUp 0.5s ease;
}
</style>
